export const decodePaymentData = (encodedData) => {
  const decodedData = atob(decodeURIComponent(encodedData));
  return new URLSearchParams(decodedData);
};

export const getPaymentDataFromUrl = (paymentUrl) => {
  const url = new URL(paymentUrl, window.location.origin);
  const encodedData = url.searchParams.get("data");

  if (encodedData) {
    return decodePaymentData(encodedData);
  }

  if (url.searchParams.toString()) {
    return url.searchParams;
  }

  const paymentPath = ["/add-card/", "/verify-card/", "/verify-wallet/"]
    .map((marker) => ({ marker, index: url.pathname.indexOf(marker) }))
    .find(({ index }) => index >= 0);

  if (!paymentPath) {
    return url.searchParams;
  }

  const tokenPath = url.pathname.slice(
    paymentPath.index + paymentPath.marker.length
  );
  const pathParts = tokenPath.split("/");
  const tokenCandidates = [
    tokenPath,
    pathParts.slice(1).join("/"),
    pathParts[pathParts.length - 1],
  ].filter(Boolean);

  for (const token of [...new Set(tokenCandidates)]) {
    try {
      const params = decodePaymentData(token);
      if (params.toString()) {
        return params;
      }
    } catch (error) {
      // Try the next path shape (with or without a gateway segment).
    }
  }

  return url.searchParams;
};

export const hasCompletePayMayaData = (params, routeGateway) => {
  const gateway = params.gateway ?? routeGateway;
  if (gateway?.toLowerCase() !== "paymaya") {
    return false;
  }

  return ["action", "authToken", "callBackUrl", "tranId"].every(
    (key) => Boolean(params[key])
  );
};

export const hasCompleteCreditCorpData = (params, routeGateway) => {
  const gateway = params.gateway ?? routeGateway;
  if (gateway?.toLowerCase() !== "creditcorp") {
    return false;
  }

  return ["fleetId", "f", "i", "t", "tranId"].every((key) =>
    Boolean(params[key])
  );
};

export const hasCompleteAvisData = (params, routeGateway) => {
  const gateway = params.gateway ?? routeGateway;
  if (gateway?.toLowerCase() !== "avis") {
    return false;
  }

  return ["fleetId", "f", "i", "t", "tranId", "callBackUrl"].every(
    (key) => Boolean(params[key])
  );
};
